<script>
export default {
  name: 'interview',
  components: {
    ModalShowMessage: () => import('@/components/general/ModalShowMessage')
  },
  created () {
    // eslint-disable-next-line no-undef
    zE('webWidget', 'hide')
  },
  beforeRouteLeave (to, from, next) {
    // eslint-disable-next-line no-undef
    zE('webWidget', 'show')
    next()
  },
  data () {
    return {
      iframeUrl: null,
      loading: true,
      showErrorModal: false,
      errorTitle: '',
      errorDescription: ''
    }
  },
  computed: {
    errorTitles () {
      return {
        'room not active': 'interview:error.room_not_active.title'
      }
    },
    errorDescriptions () {
      return {
        'room not active': 'interview:error.room_not_active.description'
      }
    }
  },
  methods: {
    closeErrorModal () {
      this.showErrorModal = false
      this.$router.push({ name: 'individual.home' })
    }
  },
  mounted () {
    document.body.style.overflow = 'hidden'
    document.documentElement.style.overflow = 'hidden'
    this.$store.dispatch('attemptGetMeetDetails', this.$route.params.id)
      .then(({ data }) => {
        const userName = encodeURIComponent(data.user_name || 'User')
        const authToken = encodeURIComponent(data.auth_token || '')
        const lang = data.lang === 'pt' ? 'pt-BR' : 'en'
        this.iframeUrl = `${data.domain}/meeting?auth_token=${authToken}&name=${userName}&lang=${lang}`
        this.loading = false
      })
      .catch((error) => {
        console.error('Error loading meeting details:', error)
        this.loading = false
        const errorMsg = error?.response?.data?.msg || 'default'
        this.errorTitle = this.errorTitles[errorMsg] || this.errorTitles.default
        this.errorDescription = this.errorDescriptions[errorMsg] || this.errorDescriptions.default
        this.showErrorModal = true
      })
  },
  beforeDestroy () {
    document.body.style.overflow = ''
    document.documentElement.style.overflow = ''
  }
}
</script>
<template>
  <div id="meet-container">
    <div v-if="loading" class="loading-spinner">
      <span>{{ $t('global:loading') }}...</span>
    </div>
    <iframe
      v-else
      id="meet"
      :src="iframeUrl"
      allow="camera *;microphone *;display-capture *"
    ></iframe>
    <modal-show-message
      v-if="showErrorModal"
      :title="errorTitle"
      :text="$t(errorDescription)"
      @close="closeErrorModal"
    />
  </div>
</template>
<style lang="scss" scoped>
#meet-container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
}

#meet {
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  border: 0;
  margin: 0;
  padding: 0;
  display: block;
}

@media only screen and (max-width: 768px) {
  #meet-container {
    height: 100dvh; // Dynamic viewport height for mobile browsers (accounts for browser UI)
    height: -webkit-fill-available; // Fallback for Safari iOS
  }
  #meet {
    width: 100%;
    height: 100%;
    min-height: 100%;
  }
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-size: 18px;
  color: #666;
}
</style>
